var _effectorFileName = "/builds/gmini/ui-common/src/FileViewer/FileViewer.tsx";
import "core-js/modules/es.array.map.js";
import ImageGallery from 'react-image-gallery';
import { Popup } from '../Popup';
import { RoundedCross } from '../icons';
import { IconButton } from './FileViewer.styled';
import 'react-image-gallery/styles/css/image-gallery.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var FileViewer = function FileViewer(_ref) {
  var linkList = _ref.linkList,
      startIndex = _ref.startIndex,
      open = _ref.open,
      setOpen = _ref.setOpen;
  return /*#__PURE__*/_jsx(Popup, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    width: "max-content",
    children: /*#__PURE__*/_jsx(ImageGallery, {
      renderCustomControls: function renderCustomControls() {
        return /*#__PURE__*/_jsx(IconButton, {
          onClick: function onClick() {
            return setOpen(false);
          },
          children: /*#__PURE__*/_jsx(RoundedCross, {
            color: "white",
            width: "28px",
            height: "28px"
          })
        });
      },
      showThumbnails: false,
      showPlayButton: false,
      items: linkList.map(function (link) {
        return {
          original: link
        };
      }),
      startIndex: startIndex
    })
  });
};